import styled from 'styled-components';
import Toast from 'react-bootstrap/Toast';

export const CustomToastBody = styled(Toast.Body)`
  background-color: #36383d;
  color: #FEC307;
  border-radius: 10px;
  z-index: 9999;
`;